var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 24,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 20 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1F2124",
  fillRule: "evenodd",
  d: "M7.375 2.25c0-1.243.881-2.25 1.969-2.25h1.312c1.088 0 1.969 1.007 1.969 2.25V24h-5.25zm1.969-.75c-.363 0-.656.336-.656.75V22.5h2.624V2.25c0-.414-.293-.75-.656-.75zM.813 12.75c0-1.243.88-2.25 1.968-2.25h1.313c1.087 0 1.968 1.007 1.968 2.25V24H.813zM2.78 12c-.362 0-.656.335-.656.75v9.75H4.75v-9.75c0-.415-.294-.75-.656-.75zM15.906 6c-1.087 0-1.969 1.007-1.969 2.25V24h5.25V8.25c0-1.243-.88-2.25-1.968-2.25zm-.656 2.25c0-.414.294-.75.656-.75h1.313c.362 0 .656.336.656.75V22.5H15.25z",
  clipRule: "evenodd"
})));
export default SvgChart;